// components/Contact/ContactSnackbar.jsx
import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import PropTypes from "prop-types";

// Alert component using MUI's Alert with custom styling and elevation
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

/**
 * ContactSnackbar
 * Snackbar component to display form submission feedback (success, error, etc.)
 *
 * Props:
 * - open: Boolean that determines if the snackbar is visible
 * - severity: One of "success", "error", "info", or "warning"
 * - message: The text message to display
 * - handleClose: Function to close the snackbar
 */
export default function ContactSnackbar({ open, severity, message, handleClose }) {
  return (
    <Snackbar
      open={open}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
        {message}
      </Alert>
    </Snackbar>
  );
}

// Prop type validation for better maintainability and ESLint compliance
ContactSnackbar.propTypes = {
  open: PropTypes.bool.isRequired,
  severity: PropTypes.oneOf(["success", "error", "warning", "info"]).isRequired,
  message: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
};
